<template>
  <div class="dashboard-container">
    <!-- 顶部概览卡片 -->
    <div class="overview-cards">
      <div class="stat-card primary">
        <div class="card-content">
          <div class="card-icon">👥</div>
          <div class="card-title">用户总数</div>
        </div>
        <div class="card-content">
          <div class="card-value">{{ data.memberTotal }}</div>
          <div class="card-unit">人</div>
        </div>
      </div>

      <div class="stat-card secondary">
        <div class="card-content">
          <div class="card-icon">🏢</div>
          <div class="card-title">商家总数</div>
        </div>
        <div class="card-content">
          <div class="card-value">{{ data.merchantTotal }}</div>
          <div class="card-unit">家</div>
        </div>
      </div>

      <div class="stat-card success">
        <div class="card-content">
          <div class="card-icon">💼</div>
          <div class="card-title">可用职位</div>
        </div>
        <div class="card-content">
          <div class="card-value">{{ data.jobTotal }}</div>
          <div class="card-unit">个</div>
        </div>
      </div>

      <div class="stat-card warning">
        <div class="card-content">
          <div class="card-icon">📊</div>
          <div class="card-title">所有职位</div>
        </div>
        <div class="card-content">
          <div class="card-value">{{ data.allJobTotal }}</div>
          <div class="card-unit">个</div>
        </div>
      </div>
    </div>
    <!-- 时间筛选器 -->
    <div class="date-picker-container">
      <div class="date-picker-wrapper">
        <div class="date-picker-content">
          <div class="date-picker-label">📅 数据时间范围</div>

          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            @change="changeDate"
            class="custom-date-picker"
          />
          <el-button type="primary" @click="changeDate" size="small"
            >搜索</el-button
          >
        </div>
      </div>
    </div>
    <!-- 累计数据卡片 -->
    <div class="cumulative-cards">
      <div
        class="cumulative-card"
        v-for="(item, index) in member_merchant_list"
        :key="index"
        v-loading="item.loading"
      >
        <div class="cumulative-header">
          <h3>{{ item.title }}</h3>
          <span class="date-label">截止到 {{ value1[1] }}</span>
        </div>
        <div class="cumulative-value">{{ item.totalMoney }}</div>
      </div>
    </div>

    <!-- 统计指标卡片 -->
    <div class="metrics-grid">
      <div
        class="metric-card"
        v-for="(item, index) in statisticList"
        :key="index"
        v-loading="item.loading"
      >
        <div class="metric-header-container">
          <div class="metric-header-left">
            <div class="metric-icon">
              <img src="../../assets/img/GMV.png" alt="icon" />
            </div>
            <h3 class="metric-title">
              <span>{{ item.title }}</span>
              <div class="metric-description" v-if="item.tips">
                {{ item.tips }}
              </div>
            </h3>
          </div>
          <div class="metric-header-right">
            {{ item.totalMoney }}
            <i
              class="el-icon-zoom-in enlargement"
              @click="enlargement(index)"
            ></i>
          </div>
        </div>

        <div class="metric-comparison">
          <span v-if="item.title == '职位应聘CVR'" class="metric-detail">
            报名:{{ item.total_applicant }} / 浏览:{{ item.total_require }}
          </span>
          <div v-else></div>
          <div class="metric-comparison-container">
            <span class="comparison-label">与上周期相比：</span>
            <div class="comparison-value">
              <span
                class="comparison-number"
                :class="{
                  positive: item.diff > 0,
                  negative: item.diff < 0,
                  neutral: item.diff === 0
                }"
              >
                {{ item.diff }}{{ item.unit }}
              </span>
              <i
                :class="
                  item.diff > 0
                    ? 'el-icon-top'
                    : item.diff < 0
                    ? 'el-icon-bottom'
                    : 'el-icon-minus'
                "
              ></i>
            </div>
          </div>
        </div>

        <div :id="item.id" class="metric-chart"></div>
      </div>
    </div>

    <!-- 底部综合图表 -->
    <div class="charts-section">
      <div class="chart-card">
        <div class="chart-header">
          <h3>👥 用户统计信息</h3>
        </div>
        <div id="memberData" class="chart-container"></div>
      </div>

      <div class="chart-card">
        <div class="chart-header">
          <h3>🏢 商家统计信息</h3>
        </div>
        <div id="merchantData" class="chart-container"></div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="80vw"
      append-to-body
      custom-class="chart-dialog"
      :before-close="closeDialog"
    >
      <div class="chart-dialog-container">
        <div
        class="metric-card-dialog"
       
        :key="chartIndex"
        v-loading="statisticList[chartIndex].loading"
      >
        <div class="metric-header-container">
          <div class="metric-header-left">
            <div class="metric-icon">
              <img src="../../assets/img/GMV.png" alt="icon" />
            </div>
            <h3 class="metric-title">
              <span>{{ statisticList[chartIndex].title }}</span>
              <div class="metric-description" v-if="statisticList[chartIndex].tips">
                {{ statisticList[chartIndex].tips }}
              </div>
            </h3>
          </div>
          <div class="metric-header-right">
            {{ statisticList[chartIndex].totalMoney }}
            <i
              class="el-icon-circle-close"
              @click="closeDialog"
            ></i>
          </div>
        </div>

        <div class="metric-comparison">
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            @change="changeDate"
            class="custom-date-picker"
          />
          <span v-if="statisticList[chartIndex].title == '职位应聘CVR'" class="metric-detail">
            报名:{{ statisticList[chartIndex].total_applicant }} / 浏览:{{ statisticList[chartIndex].total_require }}
          </span>
          <div v-else></div>
          
          <div class="metric-comparison-container">
            <span class="comparison-label">与上周期相比：</span>
            <div class="comparison-value">
              <span
                class="comparison-number"
                :class="{
                  positive: statisticList[chartIndex].diff > 0,
                  negative: statisticList[chartIndex].diff < 0,
                  neutral: statisticList[chartIndex].diff === 0
                }"
              >
                {{ statisticList[chartIndex].diff }}{{ statisticList[chartIndex].unit }}
              </span>
              <i
                :class="
                  statisticList[chartIndex].diff > 0
                    ? 'el-icon-top'
                    : statisticList[chartIndex].diff < 0
                    ? 'el-icon-bottom'
                    : 'el-icon-minus'
                "
              ></i>
            </div>
          </div>
        </div>
        <div :id="statisticList[chartIndex].id+'_dialog'" class="metric-chart"></div>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formatDate } from "@/utils/index";
import * as echarts from "echarts";
import {
  getNewUserCount,
  getSubscriptionNoticeCount,
  dataBoard,
  getMemberActiveCount,
  getStatistics,
  getLaborDemandRate,
  getMemberCount,
  getTotalMemberCount,
  getBltv,
  getJobTotal,
  getC_average_income,
  getAverageTime
} from "../../api/userMG";
import resize from "./mixins/resize.js";
const unit = [
  "",
  "元",
  "元",
  "%",
  "分钟",
  "%",
  "%",
  "%",
  "人",
  "人",
  "人",
  "个",
  "个",
  "个",
  "元",
  "元",
  "个",
  "个",
  "个"
];
export default {
  mixins: [resize],
  data() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const firstDay = formatDate(new Date(currentYear, currentMonth, 1));
    const lastDay = formatDate(new Date(currentYear, currentMonth + 1, 0));

    return {
      dialogVisible: false,
      chartIndex: 0,
      echartsObj: {},
      value1: [firstDay, lastDay],
      value2: [firstDay, lastDay],
      activeTotal: 0,
      statisticList: [
        {
          title: "GMV",
          id: "total_salary",
          totalMoney: 0,
          unit: "元",
          tips: "指定期间内的总报酬金额",
          diff: 0
        },
        {
          title: "收入",
          id: "total_service_fee",
          totalMoney: 0,
          unit: "元",
          tips: "指定期间内手续费、广告费等总收入",
          diff: 0
        },
        {
          title: "平均手续费率", //特定时间段的手续费总额 ÷ 特定时间段内支付的工资总额
          id: "average_service_fee",
          totalMoney: 0,
          unit: "%",
          tips: "指定期间内平均手续费率",
          diff: 0
        },
        {
          title: "平均招聘完成所需时间", //job表的create_time-apply表的apply_time,单位分钟
          id: "average_time",
          totalMoney: 0,
          unit: "分钟",
          tips: "指定期间内平均招聘完成所需时间",
          diff: 0
        },
        {
          //apply表的报名人数/需求人数(job的需求人数people_require*天数(job_sub的个数))
          // 先拿到需求人数,再乘以天数(job_sub的个数)
          // 再拿到报名人数/需求人数
          // 再计算满足率
          title: "劳动力需求满足率",
          id: "labor_demand_rate",
          totalMoney: 0,
          unit: "%",
          tips: "指定期间内劳动力需求满足率",
          diff: 0
        },
        {
          //  工作完成人数/需求人数
          title: "工作完成率",
          id: "work_completion_rate",
          totalMoney: 0,
          unit: "%",
          tips: "指定期间内工作完成率",
          diff: 0
        },
        {
          //  职位浏览到报名的转化比例
          title: "职位应聘CVR",
          id: "job_cvr",
          totalMoney: 0,
          unit: "%",
          tips: "指定期间内职位应聘CVR",
          diff: 0
        },
        {
          title: "新增注册用户数",
          id: "new_member_count",
          totalMoney: 0,
          unit: "人",
          tips: "指定期间内新增注册用户数",
          diff: 0
        },
        {
          // 指定期间内求职者活跃用户数,也就是apply表的apply_time在指定期间内的用户数
          title: "求职者活跃用户数",
          id: "active_member_count",
          totalMoney: 0,
          unit: "人",
          tips: "指定期间内求职者活跃用户数",
          diff: 0
        },
        {
          // 指定期间内订阅兼职更新的用户数
          title: "更新信息订阅数",
          id: "subscription_notice_count",
          totalMoney: 0,
          unit: "人",
          tips: "指定期间内更新信息订阅数",
          diff: 0
        },
        {
          //
          title: "新增注册商家数",
          id: "new_merchant_count",
          totalMoney: 0,
          unit: "家",
          tips: "指定期间内新增注册企业数",
          diff: 0
        },
        {
          title: "活跃商家数",
          id: "active_merchant_count",
          totalMoney: 0,
          unit: "家",
          tips: "指定期间内活跃商家数",
          diff: 0
        },
        {
          title: "职位发布数",
          id: "job_total",
          totalMoney: 0,
          unit: "个",
          tips: "指定期间内职位发布数",
          diff: 0
        },

        {
          // 指定期间内,当日的总收入/当日的商家数
          title: "B端 LTV",
          id: "b_ltv",
          totalMoney: 0,
          unit: "元",
          tips: "企业平均生命周期价值",
          diff: 0
        },
        {
          // 计算方式: 指定期间已结算兼职的总兼职金额 / 已结算的兼职总人数
          title: "C端平均收入",
          id: "c_average_income",
          totalMoney: 0,
          unit: "元",
          tips: "指定期间内C端平均收入",
          diff: 0
        }
      ],
      member_merchant_list: [
        {
          title: "注册总用户数",
          id: "total_member_count",
          totalMoney: 0,
          unit: "人",
          tips: "截止到指定期间的结束日期内注册总用户数",
          diff: 0
        },
        {
          title: "注册总企业数",
          id: "total_merchant_count",
          totalMoney: 0,
          unit: "家",
          tips: "截止到指定期间的结束日期内注册总企业数",
          diff: 0
        },
        {
          title: "累计工作次数",
          id: "total_work_count",
          totalMoney: 0,
          unit: "次",
          tips: "截止到指定期间的结束日期内累计工作次数",
          diff: 0
        }
      ],
    
      dateType: "month",
      data: {
        memberTotal: 0,
        merchantTotal: 0,
        jobTotal: 0,
        allJobTotal: 0
      },
      unit
    };
  },
  mounted() {
    this.setDateType();
    this.getC_average_income();
    this.getAverageTime();
    this.getJobTotal();
    this.getBltv();
    this.getTotalMemberCount("total_member_count");
    this.getTotalMemberCount("total_merchant_count");
    this.getTotalMemberCount("total_work_count");
    this.getNewUserCount("new_merchant_count");
    this.getNewUserCount("active_merchant_count");
    this.getSubscriptionNoticeCount();
    this.getStatistics();
    this.getLaborDemandRate("labor_demand_rate");
    this.getLaborDemandRate("work_completion_rate");
    this.getLaborDemandRate("job_cvr");
    this.dataBoards();
    this.getMemberActiveCount();
    this.getMemberCount();
    this.getMemberActiveCount();
  },
  computed: {},
  methods: {
    changeDate2() {
      // this.setDateType();
      // this.getC_average_income();
      // this.getAverageTime();
      // this.getJobTotal();
      // this.getBltv();
      // this.getNewUserCount("new_merchant_count");
      // this.getNewUserCount("active_merchant_count");
      // this.getSubscriptionNoticeCount();
      // this.getStatistics();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    enlargement(index) {
      this.dialogVisible = true;
     this.chartIndex = index;
     this.$nextTick(() => {
      let dom = document.getElementById(this.statisticList[this.chartIndex].id + "_dialog");
      let data = this.statisticList[this.chartIndex].data;
      console.log(data,'data')
      console.log(dom,'dom')
      this.setEcharts(data, dom, "", "#92cd75", this.chartIndex);
     })
    },
    changeDate() {
      this.setDateType();
      this.getC_average_income();
      this.getAverageTime();
      this.getJobTotal();
      this.getBltv();
      this.getNewUserCount("new_merchant_count");
      this.getNewUserCount("active_merchant_count");
      this.getSubscriptionNoticeCount();
      this.getStatistics();
      this.getLaborDemandRate("labor_demand_rate");
      this.getLaborDemandRate("work_completion_rate");
      this.getLaborDemandRate("job_cvr");
      this.getMemberCount();
      this.getMemberActiveCount();
      this.getTotalMemberCount("total_member_count");
      this.getTotalMemberCount("total_merchant_count");
      this.getTotalMemberCount("total_work_count");
    },
    getOptimalGranularity(startDate, endDate, requestedGranularity) {
      const daysDiff = Math.ceil(
        (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)
      );

      // 如果前端指定了颗粒度，优先使用
      if (requestedGranularity) {
        return requestedGranularity;
      }

      // 自动判断最佳颗粒度
      if (daysDiff <= 31) return "day"; // 1个月内按天
      if (daysDiff <= 93) return "week"; // 3个月内按周
      if (daysDiff <= 730) return "month"; // 2年内按月
      return "quarter"; // 超过2年按季度
    },
    setDateType() {
      this.dateType = this.getOptimalGranularity(
        this.value1[0],
        this.value1[1]
      );
    },
    getC_average_income() {
      this.statisticList[14].loading = true;
      getC_average_income({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("c_average_income");
        this.statisticList[14].loading = false;
        this.statisticList[14].totalMoney =
          res.data.current_period.total + "元";
        this.statisticList[14].diff =
          res.data.comparison.c_average_income_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.c_average_income,
            total_applicant: item.total_salary,
            total_require: item.total_member_count
          });
        });
        this.statisticList[14].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 16);
      });
    },
    getJobTotal() {
      this.statisticList[12].loading = true;
      getJobTotal({
        start_date: this.value1[0],
        end_date: this.value1[1],
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("job_total");
        this.statisticList[12].loading = false;
        this.statisticList[12].totalMoney =
          res.data.current_period.total + "个";
        this.statisticList[12].diff = res.data.comparison.job_total_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.job_total
          });
        });
        this.statisticList[12].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 13);
      });
    },
    getStatistics() {
      this.statisticList[0].loading = true;
      this.statisticList[1].loading = true;
      this.statisticList[2].loading = true;
      getStatistics({
        start_date: this.value1[0],
        end_date: this.value1[1],
        granularity: this.dateType
      }).then(res => {
        this.statisticList[0].loading = false;
        this.statisticList[1].loading = false;
        this.statisticList[2].loading = false;
        let GMV = document.getElementById("total_salary");
        let income = document.getElementById("total_service_fee");
        // let average_time = document.getElementById("average_time");
        let average_service_fee = document.getElementById(
          "average_service_fee"
        );
        let data = [];
        let data1 = [];
        let data2 = [];
        let data3 = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.total_salary
          });
          data1.push({
            day: item.time_period,
            num: item.total_service_fee
          });

          data2.push({
            day: item.time_period,
            num: (item.average_service_fee * 100).toFixed(2)
          });
          // data3.push({
          //   day: item.time_period,
          //   num: Number(item.average_time).toFixed(0)
          // });
        });

        this.statisticList[0].totalMoney =
          res.data.current_period.total.total_salary + "元";
        this.statisticList[0].diff = res.data.comparison.salary_change;
        this.statisticList[1].totalMoney =
          res.data.current_period.total.total_service_fee + "元";
        this.statisticList[1].diff = res.data.comparison.service_fee_change;

        this.statisticList[2].totalMoney =
          (res.data.current_period.total.average_service_fee * 100).toFixed(2) +
          "%";
        this.statisticList[2].diff =
          res.data.comparison.average_service_fee_change;
        // this.statisticList[3].totalMoney =
        //   res.data.current_period.total.average_time.toFixed(0) + "分钟";
        // this.statisticList[3].diff = res.data.comparison.average_time_change;
        this.statisticList[0].data = data;
        this.statisticList[1].data = data1;
        this.statisticList[2].data = data2;
        this.setEcharts(data, GMV, "", "#92cd75", 1);
        this.setEcharts(data1, income, "", "#92cd75", 2);
        this.setEcharts(data2, average_service_fee, "", "#92cd75", 3);
        // this.setEcharts(data3, average_time, "", "#92cd75", 4);
      });
    },
    getAverageTime() {
      this.statisticList[3].loading = true;
      getAverageTime({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("average_time");
        this.statisticList[3].loading = false;
        this.statisticList[3].totalMoney =
          res.data.current_period.total + "分钟";
        this.statisticList[3].diff = res.data.comparison.average_time_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.average_time
          });
        });
        this.statisticList[3].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 4);
      });
    },
    getLaborDemandRate(type) {
      this.statisticList[
        type == "labor_demand_rate" ? 4 : type == "work_completion_rate" ? 5 : 6
      ].loading = true;
      getLaborDemandRate({
        start_date: this.value1[0],
        end_date: this.value1[1],
        granularity: this.dateType,
        type: type
      }).then(res => {
        let dom = document.getElementById(type);
        this.statisticList[
          type == "labor_demand_rate"
            ? 4
            : type == "work_completion_rate"
            ? 5
            : 6
        ].loading = false;
        let data = [];
        let browse = 0;
        let apply = 0;
        res.data.current_period.data.map(item => {
          if (type == "job_cvr") {
            browse += Number(item.total_require);
            apply += Number(item.total_applicant);
          }
          data.push({
            day: item.time_period,
            num: item.rate,
            total_applicant: item.total_applicant,
            total_require: item.total_require
          });
        });
        if (type == "labor_demand_rate") {
          this.statisticList[4].totalMoney =
            res.data.current_period.total + "%";
          this.statisticList[4].diff =
            res.data.comparison.labor_demand_rate_change;
        } else if (type == "work_completion_rate") {
          this.statisticList[5].totalMoney =
            res.data.current_period.total + "%";
          this.statisticList[5].diff =
            res.data.comparison.labor_demand_rate_change;
        } else if (type == "job_cvr") {
          this.statisticList[6].totalMoney =
            res.data.current_period.total + "%";
          this.statisticList[6].total_applicant = apply;
          this.statisticList[6].total_require = browse;
          this.statisticList[6].diff =
            res.data.comparison.labor_demand_rate_change;
        }
        this.statisticList[type == "labor_demand_rate" ? 4 : type == "work_completion_rate" ? 5 : 6].data = data;
        this.setEcharts(
          data,
          dom,
          "",
          "#92cd75",
          { labor_demand_rate: 5, work_completion_rate: 6, job_cvr: 7 }[type]
        );
      });
    },
    getMemberCount() {
      this.statisticList[7].loading = true;
      getMemberCount({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("new_member_count");
        this.statisticList[7].loading = false;
        this.statisticList[7].totalMoney = res.data.current_period.total + "人";
        this.statisticList[7].diff = res.data.comparison.member_count_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.new_member_count
          });
        });
        this.statisticList[7].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 8);
      });
    },
    getMemberActiveCount() {
      this.statisticList[8].loading = true;
      getMemberActiveCount({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("active_member_count");
        this.statisticList[8].loading = false;
        this.statisticList[8].totalMoney = res.data.current_period.total + "人";
        this.statisticList[8].diff = res.data.comparison.member_count_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.new_member_count
          });
        });
        this.statisticList[8].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 9);
      });
    },
    getBltv() {
      this.statisticList[13].loading = true;
      getBltv({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("b_ltv");
        this.statisticList[13].loading = false;
        this.statisticList[13].totalMoney =
          res.data.current_period.total + "元";
        this.statisticList[13].diff = res.data.comparison.bltv_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.bltv,
            total_require: item.total_salary,
            total_applicant: item.merchant_count
          });
        });
        this.statisticList[13].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 14);
      });
    },
    getTotalMemberCount(type) {
      this.member_merchant_list[
        type == "total_member_count"
          ? 0
          : type == "total_merchant_count"
          ? 1
          : 2
      ].loading = true;
      getTotalMemberCount({
        date: this.value1[1] + " 23:59:59",
        type: type
      }).then(res => {
        if (type == "total_member_count") {
          this.member_merchant_list[0].totalMoney =
            res.data.total_member_count + "人";
          this.member_merchant_list[0].loading = false;
        } else if (type == "total_merchant_count") {
          this.member_merchant_list[1].totalMoney =
            res.data.total_merchant_count + "家";
          this.member_merchant_list[1].loading = false;
        } else if (type == "total_work_count") {
          this.member_merchant_list[2].totalMoney =
            res.data.total_work_count + "次";
          this.member_merchant_list[2].loading = false;
        }
      });
    },
    getSubscriptionNoticeCount() {
      this.statisticList[9].loading = true;
      getSubscriptionNoticeCount({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType
      }).then(res => {
        let dom = document.getElementById("subscription_notice_count");
        this.statisticList[9].loading = false;
        this.statisticList[9].totalMoney = res.data.current_period.total + "人";
        this.statisticList[9].diff =
          res.data.comparison.subscription_notice_count_change;
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.subscription_notice_count
          });
        });
        this.statisticList[9].data = data;
        this.setEcharts(data, dom, "", "#92cd75", 10);
      });
    },
    getNewUserCount(type) {
      this.statisticList[type == "new_merchant_count" ? 10 : 11].loading = true;
      getNewUserCount({
        start_date: this.value1[0] + " 00:00:00",
        end_date: this.value1[1] + " 23:59:59",
        granularity: this.dateType,
        type: type
      }).then(res => {
        this.statisticList[
          type == "new_merchant_count" ? 10 : 11
        ].loading = false;
        let dom = document.getElementById(type);
        if (type == "new_merchant_count") {
          this.statisticList[10].totalMoney =
            res.data.current_period.total + "个";
          this.statisticList[10].diff =
            res.data.comparison.new_user_count_change;
        } else {
          this.statisticList[11].totalMoney =
            res.data.current_period.total + "个";
          this.statisticList[11].diff =
            res.data.comparison.new_user_count_change;
        }
        let data = [];
        res.data.current_period.data.map(item => {
          data.push({
            day: item.time_period,
            num: item.new_user_count
          });
        });
        this.statisticList[type == "new_merchant_count" ? 10 : 11].data = data;
        this.setEcharts(
          data,
          dom,
          "",
          "#92cd75",
          type == "new_merchant_count" ? 11 : 12
        );
      });
    },
    setEcharts(data, chartDom1, t, c, type) {
      var myChart = echarts.init(chartDom1);
      let xAxisData = [];
      let seriesData = [];
      data.map(item => {
        xAxisData.push(item.day);
        seriesData.push(item.num ? item.num : 0);
      });
      let series = [];
      let yAxis = [];
      let legend = "";
      let tooltip = "";
      if (type == 6 || type == 5 || type == 7 || type == 14 || type == 16) {
        legend = {
          data: [
            {
              5: "报名人数",
              6: "完成人数",
              7: "报名人数",
              14: "活跃商家数",
              16: "结算金额"
            }[type],
            {
              5: "需求人数",
              6: "需求人数",
              7: "浏览数",
              14: "收入",
              16: "结算人数"
            }[type],
            {
              5: "满足率",
              6: "完成率",
              7: "转化率",
              14: "BTV",
              16: "C端平均收入"
            }[type]
          ]
        };
        tooltip = {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        };
        yAxis = [
          {
            type: "value"
          },
          {
            type: "value",
            max: type == 13 || type == 16 ? null : 100,
            min: 0,
            axisLabel: {
              formatter:
                type == 13 ? "{value}家" : type == 16 ? "{value}元" : "{value}%"
            }
          }
        ];
        series.push(
          {
            color: "#a8de96",
            name: {
              5: "报名人数",
              6: "完成人数",
              7: "报名人数",
              14: "活跃商家数",
              16: "结算金额"
            }[type],
            yAxisIndex: type == 14 || type == 16 ? 1 : 0,
            data: data.map(item => item.total_applicant),
            type: "bar"
          },
          {
            name: {
              5: "需求人数",
              6: "需求人数",
              7: "浏览数",
              14: "收入",
              16: "结算人数"
            }[type],
            color: "#6f87d2",
            yAxisIndex: 0,
            data: data.map(item => item.total_require),
            type: "bar"
          },
          {
            name: {
              5: "满足率",
              6: "完成率",
              7: "转化率",
              14: "BTV",
              16: "C端平均收入"
            }[type],
            color: "#fac858",
            yAxisIndex: type == 14 ? 0 : 1,
            data: data.map(item => item.num),
            type: "line"
          }
        );
      } else {
        tooltip = {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
            return params[0].name + "<br/>" + params[0].value + unit[type];
          }
        };
        yAxis = [
          {
            type: "value",
            max: type == 3 ? 30 : null
          }
        ];
        series = [
          {
            barWidth: 16,
            data: seriesData,
            type: "bar"
          }
        ];
      }

      let option = {
        backgroundColor: "#fff",
        legend: legend,
        color: c,
        tooltip: tooltip,
        title: {
          text: t,
          padding: [16, 0, 0, 16]
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xAxisData
        },
        yAxis: yAxis,
        series: series
      };
      option && myChart.setOption(option);
      this.echartsObj[type] = myChart;
    },
    dataBoards() {
      dataBoard().then(res => {
        if (res.message == "未登录") {
          this.$store.commit("logout", "false");
          this.$router.push({ path: "/login" });
          return;
        }
        this.data = res.data;
        this.$nextTick(() => {
          var chartDom1 = document.getElementById("memberData");
          var chartDom2 = document.getElementById("merchantData");

          chartDom1 &&
            this.setEcharts(
              this.data.memberData,
              chartDom1,
              "用户统计信息",
              "#92cd75",
              17
            );
          chartDom2 &&
            this.setEcharts(
              this.data.merchantData,
              chartDom2,
              "商家统计信息",
              "#546fc6",
              18
            );
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dashboard-container {
  height: 100%;
  overflow: auto;
  background: radial-gradient(
      ellipse at top left,
      rgba(201, 160, 220, 0.5) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at top right,
      rgba(138, 180, 248, 0.5) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at bottom left,
      rgba(248, 200, 220, 0.5) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at bottom right,
      rgba(138, 180, 248, 0.5) 0%,
      transparent 50%
    ),
    /* 基础半透明背景 */ rgba(255, 255, 255, 0.1);

  /* 高强度磨砂玻璃效果 */
  backdrop-filter: blur(18px) saturate(1.5);
  -webkit-backdrop-filter: blur(18px) saturate(1.5);
  backdrop-filter: blur(20px);
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* 顶部概览卡片 */
.overview-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 14px;
}

.stat-card {
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  .card-content {
    display: flex;
    align-items: baseline;
  }
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 20px 20px 0 0;
  }

  &.primary::before {
    background: linear-gradient(90deg, #007aff, #5ac8fa);
  }

  &.secondary::before {
    background: linear-gradient(90deg, #5856d6, #af52de);
  }

  &.success::before {
    background: linear-gradient(90deg, #34c759, #30d158);
  }

  &.warning::before {
    background: linear-gradient(90deg, #ff9500, #ffcc02);
  }

  .card-icon {
    font-size: 32px;
    display: inline-block;
  }

  .card-content {
    display: flex;
    .card-title {
      font-size: 14px;
      color: #8e8e93;
      font-weight: 500;
    }

    .card-value {
      font-size: 36px;
      font-weight: 700;
      color: #1d1d1f;
      font-family: "SF Pro Display", -apple-system, sans-serif;
    }

    .card-unit {
      font-size: 14px;
      color: #8e8e93;
      font-weight: 500;
    }
  }
}

/* 累计数据卡片 */
.cumulative-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 14px;
}

.cumulative-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  }

  .cumulative-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #1d1d1f;
      margin: 0;
    }

    .date-label {
      font-size: 12px;
      color: #8e8e93;
      background: rgba(0, 122, 255, 0.1);
      padding: 4px 8px;
      border-radius: 8px;
    }
  }

  .cumulative-value {
    font-size: 28px;
    font-weight: 700;
    color: #007aff;
    font-family: "SF Pro Display", -apple-system, sans-serif;
  }
}

/* 时间筛选器 */
.date-picker-container {
  margin-bottom: 14px;
}

.date-picker-wrapper {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);

  .date-picker-label {
    margin-right: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #1d1d1f;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.custom-date-picker {
  margin-right: 10px;
  width: 400px;

  :deep(.el-input__wrapper) {
    border-radius: 12px;
    border: 1px solid rgba(0, 122, 255, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 12px 16px;
  }
}

/* 指标网格 一排三个 设置card的最小宽度为400px */
.metrics-grid {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.metric-card {
  box-sizing: border-box;
  min-width: 400px;
  width: 32.8%;
  margin-bottom: 20px;

  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &:hover {
    transform: translateY(-3px);
    transform: translateY(-5px) scale(1.01);
    backdrop-filter: blur(20px) saturate(1.8);
    -webkit-backdrop-filter: blur(20px) saturate(1.8);

    /* 悬停时渐变更明显 */
    background: radial-gradient(
        ellipse at top left,
        rgba(201, 160, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at top right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom left,
        rgba(248, 200, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      rgba(255, 255, 255, 0.15);

    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6),
      0 2px 0 rgba(255, 255, 255, 0.4) inset, 0 -2px 0 rgba(0, 0, 0, 0.1) inset,
      0 0 30px rgba(201, 160, 220, 0.3);
  }

  .metric-header-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;

    .metric-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .metric-header-right {
      font-size: 28px;
      font-weight: 600;
      color: #1d1d1f;
    }
    .metric-icon {
      width: 50px;
      height: 50px;
      border-radius: 12px;
      background: linear-gradient(135deg, #007aff, #5ac8fa);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);

      img {
        width: 20px;
        height: 20px;
        filter: brightness(0) invert(1);
      }
    }

    .metric-title {
      font-size: 18px;
      font-weight: 600;
      color: #1d1d1f;
      margin: 0;
    }
  }

  .metric-value-container {
    margin-bottom: 20px;

    .metric-value {
      font-size: 32px;
      font-weight: 700;
      color: #1d1d1f;
      margin-bottom: 8px;
      font-family: "SF Pro Display", -apple-system, sans-serif;

      .metric-detail {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
        margin-left: 8px;
      }
    }
  }
  .metric-description {
    font-size: 14px;
    color: #8e8e93;
    line-height: 1.4;
  }
  .metric-comparison-container {
    display: flex;
    align-items: center;
  }
  .metric-comparison {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;

    .comparison-label {
      margin-right: 12px;
      font-size: 16px;
      color: #8e8e93;
      font-weight: 500;
    }

    .comparison-value {
      display: flex;
      align-items: center;

      .comparison-number {
        font-size: 14px;
        font-weight: 600;

        &.positive {
          color: #34c759;
        }

        &.negative {
          color: #ff3b30;
        }

        &.neutral {
          color: #8e8e93;
        }
      }

      .el-icon-top {
        font-size: 16px;
        color: #34c759;
        font-weight: bold;
      }

      .el-icon-bottom {
        font-size: 16px;
        color: #ff3b30;
        font-weight: bold;
      }

      .el-icon-minus {
        font-size: 16px;
        color: #8e8e93;
        font-weight: bold;
      }
    }
  }

  .metric-chart {
    height: 280px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(248, 250, 252, 0.5);
  }
}
.metric-card-dialog {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 100%;
  width: 100%;
  height: 100%;
  margin-bottom: 20px;

  border-radius: 20px;
  padding: 10px;
 
    /* 悬停时渐变更明显 */
    background: radial-gradient(
        ellipse at top left,
        rgba(201, 160, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at top right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom left,
        rgba(248, 200, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      rgba(255, 255, 255, 0.15);

    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6),
      0 2px 0 rgba(255, 255, 255, 0.4) inset, 0 -2px 0 rgba(0, 0, 0, 0.1) inset,
      0 0 30px rgba(201, 160, 220, 0.3);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  

  .metric-header-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;

    .metric-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .metric-header-right {
      font-size: 28px;
      font-weight: 600;
      color: #1d1d1f;
    }
    .metric-icon {
      width: 50px;
      height: 50px;
      border-radius: 12px;
      background: linear-gradient(135deg, #007aff, #5ac8fa);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);

      img {
        width: 20px;
        height: 20px;
        filter: brightness(0) invert(1);
      }
    }

    .metric-title {
      font-size: 18px;
      font-weight: 600;
      color: #1d1d1f;
      margin: 0;
    }
  }

  .metric-value-container {
    margin-bottom: 20px;

    .metric-value {
      font-size: 32px;
      font-weight: 700;
      color: #1d1d1f;
      margin-bottom: 8px;
      font-family: "SF Pro Display", -apple-system, sans-serif;

      .metric-detail {
        font-size: 14px;
        color: #8e8e93;
        font-weight: 400;
        margin-left: 8px;
      }
    }
  }
  .metric-description {
    font-size: 14px;
    color: #8e8e93;
    line-height: 1.4;
  }
  .metric-comparison-container {
    display: flex;
    align-items: center;
  }
  .metric-comparison {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 12px;

    .comparison-label {
      margin-right: 12px;
      font-size: 16px;
      color: #8e8e93;
      font-weight: 500;
    }

    .comparison-value {
      display: flex;
      align-items: center;

      .comparison-number {
        font-size: 14px;
        font-weight: 600;

        &.positive {
          color: #34c759;
        }

        &.negative {
          color: #ff3b30;
        }

        &.neutral {
          color: #8e8e93;
        }
      }

      .el-icon-top {
        font-size: 16px;
        color: #34c759;
        font-weight: bold;
      }

      .el-icon-bottom {
        font-size: 16px;
        color: #ff3b30;
        font-weight: bold;
      }

      .el-icon-minus {
        font-size: 16px;
        color: #8e8e93;
        font-weight: bold;
      }
    }
  }

  .metric-chart {
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(248, 250, 252, 0.5);
  }
}

/* 图表区域 */
.charts-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 25px;
}

.chart-card {
  background: rgba(255, 255, 255, 0.95);

  border-radius: 20px;
  padding: 25px;

  background: radial-gradient(
      ellipse at top left,
      rgba(201, 160, 220, 0.2) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at top right,
      rgba(138, 180, 248, 0.2) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at bottom left,
      rgba(248, 200, 220, 0.2) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at bottom right,
      rgba(138, 180, 248, 0.2) 0%,
      transparent 50%
    ),
    /* 基础半透明背景 */ rgba(255, 255, 255, 0.1);

  /* 高强度磨砂玻璃效果 */
  backdrop-filter: blur(18px) saturate(1.5);
  -webkit-backdrop-filter: blur(18px) saturate(1.5);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-3px);
    backdrop-filter: blur(20px) saturate(1.8);
    -webkit-backdrop-filter: blur(20px) saturate(1.8);

    /* 悬停时渐变更明显 */
    background: radial-gradient(
        ellipse at top left,
        rgba(201, 160, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at top right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom left,
        rgba(248, 200, 220, 0.5) 0%,
        transparent 50%
      ),
      radial-gradient(
        ellipse at bottom right,
        rgba(138, 180, 248, 0.5) 0%,
        transparent 50%
      ),
      rgba(255, 255, 255, 0.15);

    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6),
      0 2px 0 rgba(255, 255, 255, 0.4) inset, 0 -2px 0 rgba(0, 0, 0, 0.1) inset,
      0 0 30px rgba(201, 160, 220, 0.3);
  }

  .chart-header {
    margin-bottom: 20px;

    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #1d1d1f;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .chart-container {
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(248, 250, 252, 0.3);
  }
}
.enlargement {
  font-size: 20px;
  color: #1d1d1f;
  cursor: pointer;
  margin-left: 10px;
}
.date-picker-content {
  display: flex;
  align-items: center;
}

/* 响应式设计 */
@media (max-width: 1920px) {
  .dashboard-container {
    .metric-card {
      width: 49.5%;
    }
    .metrics-grid {
      .metric-card:nth-last-child(1) {
        width: 100%;
      }
    }
  }
}
@media (max-width: 1700px) {
  .dashboard-container {
    .metric-card {
      width: 100%;
    }
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
}
.el-icon-circle-close{
  font-size: 30px;
  color: #1d1d1f;
  cursor: pointer;
  margin-left: 40px;
}
/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card,
.cumulative-card,
.metric-card,
.chart-card {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:nth-child(2) {
  animation-delay: 0.1s;
}
.stat-card:nth-child(3) {
  animation-delay: 0.2s;
}
.stat-card:nth-child(4) {
  animation-delay: 0.3s;
}
</style>
<style lang="less">
.chart-dialog {
  .metric-comparison{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 12px;
  }
  border-radius: 20px;
  .chart-dialog-container {
    height: 60vh;
    width: 80vw;
    #chart-dialog-container {
      height: 100%;
      width: 100%;
    }
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DataBoard/index.vue